import FileUploadStatus from './FileUploadStatus';

export default FileUploadStatus;
